module.exports = __webpack_public_path__ + "img/logo.602c91a8.png";